module.exports = __webpack_public_path__ + "static/media/sinead-cassidy-design.c26fb1ec.png";